<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-row>
          <b-col md="4" class="my-1">
            <b-navbar-nav>
              <b-button @click="goBack" size="sm" variant="outline-secondary">
                <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
              </b-button>
            </b-navbar-nav>
            <h5 class="mt-1 mr-2">
              {{ $route.name }}
            </h5>
          </b-col>
          <b-col md="2">
            <h5>
              <small v-if="isLoading == false"
                >{{ getClientKycList.length }} Entries</small
              >
            </h5>
          </b-col>
          <b-col md="6">
            <b-button
              class="pull-right ml-1 mt-1"
              :variant="
                Filter.KycNoFilter ||
                Filter.commonFilter ||
                Filter.clientTypeFilter ||
                Filter.clientFilter ||
                Filter.createdByFilter ||
                Filter.statusFilter ||
                Filter.dateRange.startDate ||
                Filter.dateRange.endDate
                  ? 'outline-danger'
                  : 'outline-primary'
              "
              :class="' ml-4' + visible ? null : 'collapsed'"
              :aria-expanded="visible ? 'true' : 'false'"
              aria-controls="collapse-4"
              @click="visible = !visible"
              style="font-size: 0.675rem"
              >{{
                Filter.KycNoFilter ||
                Filter.commonFilter ||
                Filter.clientTypeFilter ||
                Filter.clientFilter ||
                Filter.createdByFilter ||
                Filter.statusFilter ||
                Filter.dateRange.startDate ||
                Filter.dateRange.endDate
                  ? "Filter ON"
                  : "Filter OFF"
              }}</b-button
            >
            <b-button
              class="pull-right ml-1 mt-1"
              v-if="getClientKycList.length > 0"
              :disabled="ExcelBtnName != 'Export As Excel' ? true : false"
              @click="getReports('getClientKycList', 'Export As Excel')"
              size="sm"
              variant="warning"
              style="font-size: 0.675rem"
            >
              {{ ExcelBtnName }}
              <b-spinner
                v-if="ExcelBtnName != 'Export As Excel'"
                small
                label="Small Spinner"
              ></b-spinner
            ></b-button>
            <b-button
              v-if="!isClientKycDash"
              size="sm"
              class="pull-right mt-1"
              @click="addClientKyc('add', '')"
              variant="primary"
              >Add</b-button
            >
            <ClientCard />
            <b-button
             class="pull-right ml-1 mt-1"
              v-if="
                ($sessionsStorage.get('designation') == 'Admin' ||
                  $sessionsStorage.get('designation') == 'HOD') &&
                !isClientKycDash
              "
              size="sm"
              @click="GoKycClient()"
              variant="primary"
              >Go To Client</b-button
            >
            
          </b-col>

          <b-col cols="12">
            <div>
              <b-pagination
                limit="25"
                align="center"
                v-model="pagination.currentPage"
                :per-page="pagination.perPage"
                :total-rows="totalData"
                @change="onPageChange($event)"
              ></b-pagination>
            </div>
          </b-col>
        </b-row>
        <div v-if="visible">
          <b-card>
            <b-collapse v-model="visible" id="collapse-2">
              <b-row>
                <b-col md="3">
                  <label>Status</label>

                  <model-list-select
                    :list="StatusList"
                    v-model="Filter.statusFilter"
                    option-value="DVal"
                    option-text="DText"
                    placeholder="Select"
                    @input="getClientKycTempList('Normal', '0', '0', '1', '1')"
                  ></model-list-select>
                </b-col>
                <b-col md="3">
                  <label>Date</label>
                  <date-range-picker
                    :always-show-calendars="showCal"
                    v-model="Filter.dateRange"
                    :startDate="startDate"
                    :endDate="endDate"
                    :locale-data="locale"
                    :disabled="Filter.DFlag ? true : false"
                    @update="getClientKycTempList('Normal', '0', '0', '1', '1')"
                  ></date-range-picker>
                </b-col>

                <b-col md="3">
                  <label>Client Type</label>
                  <model-list-select
                    :list="clientTypes"
                    v-model="Filter.clientTypeFilter"
                    option-value="clientTypeVal"
                    option-text="clientTypeText"
                    placeholder="Select Shipper Name"
                    @input="getClientKycTempList('Normal', '0', '0', '1', '1')"
                  ></model-list-select>
                </b-col>

                <b-col md="3">
                  <label>Client</label>
                  <b-form-input
                    type="text"
                    :formatter="capitalizeAll"
                    placeholder="Search Client Name Filter"
                    id="clientFilter"
                    name="clientFilter"
                    autocomplete="off"
                    v-model="Filter.clientFilter"
                    @input="getClientKycTempList('Normal', '0', '0', '1', '1')"
                  ></b-form-input>
                </b-col>

                <b-col md="3">
                  <label>Kyc No Filter</label>
                  <b-form-input
                    type="text"
                    :formatter="capitalizeAll"
                    placeholder="Search Kyc No Filter"
                    id="KycNoFilter"
                    name="KycNoFilter"
                    autocomplete="off"
                    v-model="Filter.KycNoFilter"
                    @input="getClientKycTempList('Normal', '0', '0', '1', '1')"
                  ></b-form-input>
                </b-col>
                <b-col md="3">
                  <label>Common Filter</label>
                  <b-form-input
                    type="text"
                    :formatter="capitalizeAll"
                    placeholder="Search Common Filter"
                    id="commonFilter"
                    name="commonFilter"
                    autocomplete="off"
                    v-model="Filter.commonFilter"
                    @input="getClientKycTempList('Normal', '0', '0', '1', '1')"
                  ></b-form-input>
                </b-col>
                <b-col md="3">
                  <label>
                    <b> Created User </b>
                  </label>
                  <model-list-select
                    :list="$store.getters['common/getAllUserList']"
                    id="createdByFilter"
                    @input="getClientKycTempList('Normal', '0', '0', '1', '1')"
                    v-model="Filter.createdByFilter"
                    option-value="userId"
                    option-text="employeeName"
                    placeholder="Select Created User"
                  ></model-list-select>
                </b-col>
                <b-col md="12" class="mt-2">
                  <b-button
                    size="sm"
                    style="margin-left: auto"
                    class="ml-1 pull-right"
                    @click="clearFilter"
                    variant="outline-danger"
                    >Reset</b-button
                  >
                </b-col>
              </b-row>
            </b-collapse>
          </b-card>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="table-responsive tableMain gutr" v-if="!isClientKycDash">
              <b-table
                show-empty
                stacked="md"
                responsive
                :items="getClientKycList"
                :fields="PrerequisiteFields"
                primary-key="id_email_section"
                :per-page="pagination.perPage"
                :filter="filter"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :sort-direction="sortDirection"
                @filtered="onFiltered"
                class="position-relative"
              >
                <template slot="SN" slot-scope="row0">
                  <span>{{
                    row0.index + 1 + (pagination.currentPage - 1) * pagination.perPage
                  }}</span>
                </template>

                <template slot="kyc_no" slot-scope="row1">
                  <span>Client Kyc No : {{ row1.item.kyc_no }}</span>
                  <span>TAN No : {{ row1.item.tan }}</span>
                </template>

                <template slot="client_doc" slot-scope="row1">
                  <div v-if="row1.item.client_doc">
                    <b-button
                      v-for="(item1, index) in row1.item.client_doc.split(',')"
                      :key="index"
                      style="margin-left: 2px; font-size: 0.675rem"
                      @click="item1 ? PrintValidity_Doc(item1) : ''"
                      size="sm"
                      variant="warning"
                      class="mb-1"
                      >{{ item1 ? "PDF" + (parseInt(index) + 1) : "" }}</b-button
                    >
                  </div>
                </template>

                <template slot="raisedBy" slot-scope="row3">
                  <span v-if="row3.item.raisedBy"
                    >Raised By : {{ row3.item.raisedBy }}<br
                  /></span>
                  <span v-if="row3.item.create_date"
                    >Created Date : {{ row3.item.create_date }}<br
                  /></span>
                  <span v-if="row3.item.updatedBy"
                    >Updated By : {{ row3.item.updatedBy }}<br
                  /></span>
                  <span v-if="row3.item.update_date"
                    >Updated Date : {{ row3.item.update_date }}<br
                  /></span>

                  <b-button
                    size="sm"
                    class="ml-2"
                    @click="addClientKyc('edit', row3.item)"
                    variant="primary"
                    >{{
                      row3.item.client_kyc_is_converted === "1" ? "View" : "Edit"
                    }}</b-button
                  >
                  <b-button
                    v-if="
                      ($sessionsStorage.get('designation') == 'Admin' ||
                        $sessionsStorage.get('designation') == 'HOD') &&
                      !isClientKycDash &&
                      row3.item.client_kyc_is_converted == 0
                    "
                    size="sm"
                    class="ml-2"
                    @click="ConvertKycClient(row3.item)"
                    variant="primary"
                    >Convert To Client</b-button
                  >
                </template>
              </b-table>
            </div>
            <div class="table-responsive tableMain gutr" v-else-if="isClientKycDash">
              <b-table
                show-empty
                stacked="md"
                responsive
                :items="getClientKycList"
                :fields="ClientKYCDashFields"
                primary-key="id_email_section"
                :per-page="pagination.perPage"
                :filter="filter"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :sort-direction="sortDirection"
                @filtered="onFiltered"
                class="position-relative"
              >
                <template slot="SN" slot-scope="row0">
                  <span>{{
                    row0.index + 1 + (pagination.currentPage - 1) * pagination.perPage
                  }}</span>
                </template>
                <template slot="client_name" slot-scope="row1">
                  <span>Client Name : {{ row1.item.client_name }}</span
                  ><br />
                  <span v-if="isClientKycDash">TAN : {{ row1.item.tan }}</span>
                </template>
                <template slot="kyc_no" slot-scope="row1">
                  <span>Client Kyc No : {{ row1.item.kyc_no }}</span>
                </template>

                <template slot="kam_name" slot-scope="row1">
                  <span>Name : {{ row1.item.kam_name }}<br /></span>
                  <span v-if="isClientKycDash"
                    >Email : {{ row1.item.kam_email }}<br
                  /></span>
                  <span v-if="isClientKycDash"
                    >Mobile : {{ row1.item.kam_mobile }}<br
                  /></span>
                  <span v-if="isClientKycDash"
                    >Designation : {{ row1.item.kam_designation }}</span
                  >
                </template>

                <template slot="quest_export_import" slot-scope="row1">
                  <span v-if="isClientKycDash"
                    >Deal Type : {{ row1.item.quest_export_import }}</span
                  ><br />
                  <span v-if="isClientKycDash"
                    >CC :
                    {{
                      row1.item.quest_cc == "1"
                        ? "YES"
                        : row1.item.quest_cc == "0"
                        ? "No"
                        : "NA"
                    }}</span
                  ><br />
                  <span v-if="isClientKycDash"
                    >FF :
                    {{
                      row1.item.quest_ff == "1"
                        ? "YES"
                        : row1.item.quest_ff == "0"
                        ? "No"
                        : "NA"
                    }}</span
                  ><br />
                  <span v-if="row1.item.quest_ff == '1' && isClientKycDash"
                    >Container Type : {{ row1.item.containerType }}</span
                  ><br />
                  <span v-if="row1.item.quest_ff == '1' && isClientKycDash"
                    >Volume : {{ row1.item.quest_monthly_volume }}</span
                  >
                  <span v-if="row1.item.quest_ff == '1' && isClientKycDash"
                    >NOMINATION SHIPPER : {{ row1.item.nominationShipperStatus }}</span
                  >
                  <span v-if="row1.item.quest_ff == '0' && isClientKycDash"
                    >FF NA Reason :
                    {{
                      row1.item.quest_ff_option == "0"
                        ? "NOMINATION SHIPPER"
                        : row1.item.quest_ff_option == "1"
                        ? "ALL NOMINATION"
                        : row1.item.quest_ff_option == 2
                        ? "ALL DIRECT SLINE CONTRACTS"
                        : "NA"
                    }}</span
                  >
                </template>

                <template slot="client_doc" slot-scope="row1">
                  <div v-if="row1.item.client_doc">
                    <b-button
                      v-for="(item1, index) in row1.item.client_doc.split(',')"
                      :key="index"
                      style="margin-left: 2px; font-size: 0.675rem"
                      @click="item1 ? PrintValidity_Doc(item1) : ''"
                      size="sm"
                      variant="warning"
                      class="mb-1"
                      >{{ item1 ? "PDF" + (parseInt(index) + 1) : "" }}</b-button
                    >
                  </div>
                </template>

                <template slot="raisedBy" slot-scope="row3">
                  <span v-if="row3.item.raisedBy"
                    >Raised By : {{ row3.item.raisedBy }}<br
                  /></span>
                  <span v-if="row3.item.create_date"
                    >Created Date : {{ row3.item.create_date }}<br
                  /></span>
                  <span v-if="row3.item.updatedBy"
                    >Updated By : {{ row3.item.updatedBy }}<br
                  /></span>
                  <span v-if="row3.item.update_date"
                    >Updated Date : {{ row3.item.update_date }}<br
                  /></span>

                  <b-button
                    v-if="!isClientKycDash"
                    size="sm"
                    class="ml-2"
                    @click="addClientKyc('edit', row3.item)"
                    variant="primary"
                    >{{
                      row3.item.client_kyc_is_converted === "1" ? "View" : "Edit"
                    }}</b-button
                  >
                  <b-button
                    v-if="row3.item.client_kyc_is_converted == 0 && !isClientKycDash"
                    size="sm"
                    class="ml-2"
                    @click="ConvertKycClient(row3.item)"
                    variant="primary"
                    >Convert To Client</b-button
                  >
                </template>
              </b-table>
            </div>
            <div>
              <b-pagination
                limit="25"
                align="center"
                v-model="pagination.currentPage"
                :per-page="pagination.perPage"
                :total-rows="totalData"
                @change="onPageChange($event)"
              ></b-pagination>
            </div>
          </div>
        </div>
      </b-card-text>
    </b-card>
    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop"
    ></md-dialog-alert>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import CustomLoader from "../common/customLoader.vue";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import { lastVisitPage, globalPermissionStatus } from "../../helper/collection";
import DateRangePicker from "vue2-daterange-picker";
import AccountService from "../../services/AccountService.js";
import { ModelListSelect, MultiSelect } from "vue-search-select";
import Multiselect from "vue-multiselect";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant";
import ClientCard from "../common/clientCard.vue";
export default {
  // Component logic for Tab 1
  beforeMount() {
    lastVisitPage(this.$router.history.current.fullPath);

    this.$store.dispatch("setCurrentRoute", "/client/clientKycTempList");
    if (this.lastVisitPage && this.$sessionsStorage.get("lastVisitPage")) {
      this.fetchLastPage(this.lastVisitPage);
    } else {
      this.getClientKycTempList("Normal", "0", "0", "1", "1");
    }
  },
  mounted() {},
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  beforeDestroy() {},

  destroyed() {},
  data() {
    return {
      isClientKycDash: this.$route.path == "/kyc-temp/ClientKycDash" ? true : false,
      docURL: URL_BASE_DOC,
      selectDateFormat,
      lastVisitPage: this.$sessionsStorage.get("lastVisitPage"),
      ExcelBtnName: "Export As Excel",
      visible: false,
      getClientKycList: [],
      totalData: 0,
      PrerequisiteFields: [
        {
          key: "SN",
          mainkey: "SN",
          label: "SN.",
          sortable: true,
          sortDirection: "ASC",
          table: "A.",
        },

        {
          key: "kyc_no",
          mainkey: "kyc_no",
          label: "Kyc No",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "client_type",
          mainkey: "client_type",
          label: "Client Type",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "client_name",
          mainkey: "client_name",
          label: "Client Name",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "email",
          mainkey: "email",
          label: "Email",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "mobile",
          mainkey: "mobile",
          label: "Mobile",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "gst",
          mainkey: "gst",
          label: "GST No",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "pan",
          mainkey: "pan",
          label: "PAN No",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "client_doc",
          mainkey: "client_doc",
          label: "Document",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "raisedBy",
          mainkey: "raisedBy",
          label: "Action",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
      ],
      ClientKYCDashFields: [
        {
          key: "SN",
          mainkey: "SN",
          label: "SN.",
          sortable: true,
          sortDirection: "ASC",
          table: "A.",
        },

        {
          key: "kyc_no",
          mainkey: "kyc_no",
          label: "Kyc No",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "client_type",
          mainkey: "client_type",
          label: "Client Type",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "client_name",
          mainkey: "client_name",
          label: "Client Name",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "email",
          mainkey: "email",
          label: "Email",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "mobile",
          mainkey: "mobile",
          label: "Mobile",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "gst",
          mainkey: "gst",
          label: "GST No",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "pan",
          mainkey: "pan",
          label: "PAN No",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },

        {
          key: "kam_name",
          mainkey: "kam_name",
          label: "Contact Details",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "quest_export_import",
          mainkey: "quest_export_import",
          label: "Others Details",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "client_doc",
          mainkey: "client_doc",
          label: "Document",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "raisedBy",
          mainkey: "raisedBy",
          label: "Action",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
      ],
      pagination: {
        currentPage: 1,
        perPage: 25,
        pageOptions: [5, 10, 15],
      },
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: null,

      StatusList: [
        {
          DVal: "0",
          DText: "In-Active",
        },
        {
          DVal: "1",
          DText: "Active",
        },
        {
          DVal: "2",
          DText: "All",
        },
      ],

      clientTypes: [
        { clientTypeVal: null, clientTypeText: "Please Select Client Type" },
        {
          clientTypeVal: "Client",
          clientTypeText: "Client",
        },

        {
          clientTypeVal: "Overseas",
          clientTypeText: "Overseas",
        },
        {
          clientTypeVal: "Lead",
          clientTypeText: "Lead",
        },
        {
          clientTypeVal: "Transporter",
          clientTypeText: "Transporter",
        },
        {
          clientTypeVal: "Trader",
          clientTypeText: "Trader",
        },
        {
          clientTypeVal: "Freight_Forwarder",
          clientTypeText: "Freight Forwarder",
        },
      ],
      Filter: {
        KycNoFilter: "",
        commonFilter: "",
        clientTypeFilter: "",
        clientFilter: "",
        createdByFilter: "",
        statusFilter: "2",
        dateRange: {
          startDate: "",
          endDate: "",
        },
        startDate: "",
        endDate: "",
      },
      openLeft: "left",
      showCal: false,
      startDate: "2017-09-05",
      endDate: "2017-09-15",
      dateRange: {
        startDate: "",
        endDate: "",
      },
      locale: {
        direction: "ltr",
        format: "mm/dd/yyyy",
        separator: " - ",
        applyLabel: "Apply",
        cancelLabel: "Cancel",
        weekLabel: "W",
        customRangeLabel: "Custom Range",
        daysOfWeek: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        monthNames: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
        firstDay: 0,
      },
      alert: {
        content: "Are you sure you want to delete ..!",
        ok: "ok",
      },
      value1: [new Date(2019, 9, 8), new Date(2019, 9, 19)],
      value2: [],
      langType: {
        pickers: ["Today", "Yesterday", "This Month", "This Year"],
      },
      time: "",
      date: "",
      week: ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"],

      langEnq: {
        pickers: ["", "", "previous 7 days", "previous 30 days"],
      },
      isLoading: false,
    };
  },

  components: {
    CustomLoader,
    DatePicker,
    ModelListSelect,
    DateRangePicker,

    MultiSelect,
    Multiselect,
    ClientCard,
  },
  computed: {},
  watch: {
    "$route.path": {
      handler(newPath) {
        this.isClientKycDash = newPath === "/kyc-temp/ClientKycDash";
      },
      immediate: true,
    },
  },
  methods: {
    addClientKyc(type, item) {
      if (type == "edit") {
        this.$sessionsStorage.set("editClientKycId", "");
        this.$sessionsStorage.set("editClientKycId", item.kyc_id);
      } else {
        this.$sessionsStorage.set("editClientKycId", "");
      }
      this.$router.push({
        path: "/kyc-temp/addClientKyc",
      });
    },
    GoKycClient() {
      this.$router.push({
        path: "/client/viewClient",
      });
    },

    clearFilter() {
      this.Filter = {
        KycNoFilter: "",
        commonFilter: "",
        clientTypeFilter: "",
        clientFilter: "",
        createdByFilter: "",
        statusFilter: "2",
        dateRange: {
          startDate: "",
          endDate: "",
        },
        startDate: "",
        endDate: "",
      };
    },
    getCurrentLastDate() {
      var today = new Date();
      var firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
      var lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);

      var firstDay_dd = String(firstDay.getDate()).padStart(2, "0");
      var firstDay_mm = String(firstDay.getMonth() + 1).padStart(2, "0"); //January is 0!
      var firstDay_yyyy = firstDay.getFullYear();

      var lastDay_dd = String(lastDay.getDate()).padStart(2, "0");
      var lastDay_mm = String(lastDay.getMonth() + 1).padStart(2, "0"); //January is 0!
      var lastDay_yyyy = lastDay.getFullYear();

      firstDay = firstDay_yyyy + "/" + firstDay_mm + "/" + firstDay_dd; //2018-06-01
      lastDay = lastDay_yyyy + "/" + lastDay_mm + "/" + lastDay_dd; //2018-06-01

      var dd = String(today.getDate()).padStart(2, "0");
      var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      var yyyy = today.getFullYear();
      today = yyyy + "/" + mm + "/" + dd; //2018-06-01
      this.startDate = today;
      this.Filter.dateRange = {
        startDate: firstDay,
        endDate: lastDay,
      };
    },

    ConvertKycClient(item) {
      this.showModal = false;
      if (item.kyc_id > 0 && item.client_kyc_is_converted == 0) {
        let payload = {
          itemCode: "convertKycClient",
          kyc_id: item.kyc_id,
          kyc_no: item.kyc_no,
          client_kyc_is_converted: item.client_kyc_is_converted,
          client_arr: item,
        };
        AccountService.getAllClientKycList(payload)
          .then((response) => {
            const { data, status, statusText } = response;

            if (status == 200 && data) {
              this.alert.content = data.MSG;
              this.$refs["addPop"].open();
              this.getClientKycTempList("Normal", "0", "0", "1", "1");
            }

            this.isLoading = false;
          })
          .catch((error) => {
            console.log("Catch on convertKycClient Error: ", error);
          });
      } else {
        // Show validation errors to the user
        console.log("Please First Add CLient KYC");
      }
      // Proceed with the action
    },
    PrintValidity_Doc(validity_doc) {
      this.openSignedDocument(`CLIENTKYCDOC/${validity_doc}`);
    },
    getClientKycTempList(type, filterIdD, CURRENT, SEARCH, pageNumber) {
      this.getClientKycList = [];
      let payload = {};
      if (type == "Normal") {
        this.isLoading = true;
      }
      payload = {
        itemCode: "getClientKycList",
        type: type,
        DCfilterId: filterIdD,
        searchVal: this.filter,
        DCfilterId: filterIdD,
        fromSearch: SEARCH,
        currentPage: CURRENT,
        perPage: this.pagination.perPage,
        Filter: this.Filter,
      };

      AccountService.getAllClientKycList(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          console.log();
          if (status == 200 && data) {
            if (type == "Excell") {
              if (data.getClientKycList.length > 0) {
                this.totalData = data.totalRows;
                this.getClientKycList = data.getClientKycList;
              }
              this.ExcelBtnName = "Export As Excel";
              window.location.href =
                `https://uploadsp.pridel.com/Pridel_Reports/` + data.excelName;
            } else {
              if (data.getClientKycList.length > 0) {
                this.totalData = data.totalRows;
                this.getClientKycList = data.getClientKycList;
              }
            }
          }
          this.isLoading = false;
        })
        .catch((error) => {
          console.log("Catch on getClientKycList Error: ", error);
        });
    },
    onFiltered(filtered) {
      this.totalRows = filtered.length;
      this.pagination.currentPage = 1;
    },
    clearTimeout() {},
    goBack() {
      window.history.go(-1);
    },

    debounceSearch(event) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.getClientKycTempList("Normal", "0", "0", "1", "1");
      }, 1000);
    },
    getReports(id, btnName) {
      this.isLoading = true;
      this.ExcelBtnName = "Downloading Please Wait .....";
      this.getClientKycTempList("Excell", "0", "0", "1", "1");
    },
    fetchLastPage(event) {
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = parseInt(event) * this.pagination.perPage - this.pagination.perPage;
      }
      this.getClientKycTempList("Normal", "0", CURRENT, "2", event);
    },
    onPageChange: function (event) {
      this.$sessionsStorage.set("lastVisitPage", event);
      this.$sessionsStorage.set("oldRoute", this.$router.history.current.fullPath);
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = event * this.pagination.perPage - this.pagination.perPage;
      }
      this.getClientKycTempList("Normal", "0", CURRENT, "2", event);
    },
  },
};
</script>



// WEBPACK FOOTER //
// ClientKycList.vue?c5c8bfe6